import { render, staticRenderFns } from "./ITROccupationCard.vue?vue&type=template&id=066b42e6&scoped=true&"
import script from "./ITROccupationCard.vue?vue&type=script&lang=ts&"
export * from "./ITROccupationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b42e6",
  null
  
)

export default component.exports